import React, { useEffect, useMemo, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { Table, Pagination, Checkbox, Spin, Collapse, message as antMessage, Tooltip, Typography, message, Button } from 'antd';
import { CheckOutlined, CopyOutlined, LoadingOutlined } from '@ant-design/icons';
import { useCookies } from "react-cookie";
import { verifyToken, connectSocket, subscribeToChannel, unsubscribeFromChannel, placeBet, changeIssue, fetchHowToPlay, fetchUserBets, refreshBalance, fetchIssueSession } from '../components/socket';
import moment from "moment";
import ProviderCredit from '../components/ProviderCredit';
const siteColor = "#f95959";

const isValidWalletBalance = value => (typeof value === 'number' || (typeof value === 'string' && value.trim() !== '')) && Number.isFinite(Number(value));

export default function Wingo() {

    const [userToken, setUserToken] = useState(null)
    const contentRef = useRef(null);
    const [currencySymbol, setCurrencySymbol] = useState("INR");
    const [gameTime, setGameTime] = useState("30S")
    const [userDetails, setUserDetails] = useState(true);
    const [scrollPosition, setScrollPosition] = useState(0);
    const [soundOn, setSoundOn] = useState(true);
    const [siteLoading, setSiteLoading] = useState(true);
    const [showAlert, setShowAlert] = useState(false)
    const [alertMessage, setAlertMessage] = useState("")
    const [betResult, setBetResult] = useState(null);
    const [winningNumber, setWinningNumber] = useState(null);
    const params = new URLSearchParams(window.location.search);
    const allParams = {};
    for (const [key, value] of params?.entries()) {
        allParams[key] = value;

    }


    const issue = allParams?.issue || "issue1";
    const location = useLocation(); // To access the query params
    const navigate = useNavigate();
    const betParms = {};
    for (const [key, value] of params?.entries()) {
        if (key === "return_url") {
            betParms[key] = window.location.href;
        } else {
            betParms[key] = value;
        }
    }
    const [socket, setSocket] = useState(null);
    const [userBalance, setUserBalance] = useState(0);
    const [sessionHistory, setSessionHistory] = useState([]);
    const [socketConnetion, setConnection] = useState(false)
    const [notification, setNotification] = useState(null);
    const [remainingTime, setRemainingTime] = useState(0);
    const [sessionId, setSessionId] = useState(null);
    const [currentPeriod, setCurrentPeriod] = useState(null);
    const [betDetails, setBetDetails] = useState(null);
    const [betLoading, setBetLoading] = useState(false);
    const betPendingRef = useRef(false);
    const betTimerRef = useRef(null);
    const bettingOpenRef = useRef(false);
    const resetBetRequest = () => {
        betPendingRef.current = false;
        clearTimeout(betTimerRef.current);
        setBetLoading(false);
    };
    useEffect(() => () => clearTimeout(betTimerRef.current), []);
    const [howToPlayContent, setHowToPlayContent] = useState(null);
    const [issueAnalytics, setIssueAnalytics] = useState(null);
    const [betPlaced, setBetPlaced] = useState(false);

    const scrollPositionRef = useRef(scrollPosition);
    const sessionIDRef = useRef(sessionId);
    const winningNumberRef = useRef(winningNumber);
    const betPlacedRef = useRef(betPlaced);
    const socketRef = useRef(null);
    const recoveryRef = useRef(null);
    const shouldReconnectRef = useRef(false);
    const connectionGenerationRef = useRef(0);
    const verificationPendingRef = useRef(null);

    useEffect(() => {
        scrollPositionRef.current = scrollPosition;
        sessionIDRef.current = sessionId;
        winningNumberRef.current = winningNumber;
        betPlacedRef.current = betPlaced;
    }, [scrollPosition, sessionId, winningNumber, betPlaced])

    useEffect(() => {
        if (socketConnetion && socket) {
            subscribe();
        }
    }, [socketConnetion, socket])

    const verifyAndConnect = async (isCurrent = () => true) => {
        if (socketRef.current && [WebSocket.CONNECTING, WebSocket.OPEN].includes(socketRef.current.readyState)) {
            return;
        }

        const generation = connectionGenerationRef.current;
        if (verificationPendingRef.current === generation) return;
        verificationPendingRef.current = generation;
        const tokenResponse = await verifyToken(userToken);
        if (verificationPendingRef.current === generation) verificationPendingRef.current = null;
        if (!shouldReconnectRef.current || generation !== connectionGenerationRef.current || !isCurrent()) return;
        if (tokenResponse.status === true && tokenResponse?.data?.userId === allParams?.user) {
            setCurrencySymbol(tokenResponse.data.currency || 'INR');
            let ws;
            ws = connectSocket(
                userToken,
                (message) => { if (socketRef.current === ws) handleWebSocketMessage(message); },
                (error) => {
                    if (socketRef.current !== ws) return;
                    setSiteLoading(false);
                    resetBetRequest();
                },
                () => {
                    if (socketRef.current !== ws) return;
                    setSocket(ws)
                    setConnection(true)
                    setSiteLoading(false)
                    setUserDetails(tokenResponse?.data)
                },
                () => {
                    if (socketRef.current !== ws) return;
                    socketRef.current = null;
                    bettingOpenRef.current = false;
                    setSiteLoading(false);
                    resetBetRequest();
                    setConnection(false);
                    recoveryRef.current?.lost();
                }
            );
            ws.desiManaged = true;
            socketRef.current = ws;
        } else {
            setSiteLoading(false)
            setUserDetails(false)
            if (!window.DesiGameError.isBlocked()) recoveryRef.current?.lost();
        }
    };
    useEffect(() => {
        ++connectionGenerationRef.current;
        if (userToken) {
            shouldReconnectRef.current = true;
            recoveryRef.current = window.DesiGameError.createRecovery(verifyAndConnect, () => socketRef.current?.close());
            recoveryRef.current.start();
        }

        return () => {
            ++connectionGenerationRef.current;
            shouldReconnectRef.current = false;
            recoveryRef.current?.stop();
            const current = socketRef.current;
            if (current) {
                current.onopen = current.onmessage = current.onclose = current.onerror = null;
                current.close();
            }
            socketRef.current = null;
            setConnection(false)
        };
    }, [userToken]);

    useEffect(() => {
        if (gameTime?.length > 0 && socketConnetion) {
            let issue = gameTime === "30S" ? "issue1" : gameTime === "1M" ? "issue2" : gameTime === "3M" ? "issue3" : "issue4"
            _fetHowToPlayContent(issue, userToken)
        }
    }, [gameTime, socketConnetion])

    const _fetHowToPlayContent = async (issue, userToken) => {
        let howtoplaycontent = await fetchHowToPlay(issue, userToken);
        if (howtoplaycontent?.status) {
            setHowToPlayContent(howtoplaycontent?.content);
        } else {
            setHowToPlayContent("No data")
        }
    }

    const handleWebSocketMessage = (message) => {
        // console.log("message received : ",message) 

        switch (message.type) {
            case "SUBSCRIBED":
                recoveryRef.current?.ready();
                break;
            case "USER_BALANCE":
                if (isValidWalletBalance(message.userBalance)) setUserBalance(Number(message.userBalance));
                break;
            case "REFRESHED_BALANCE":
                if (isValidWalletBalance(message.balance)) setUserBalance(Number(message.balance));
                setAlertMessage("Refresh successfully");
                setShowAlert(true)
                break;
            case "SESSION_HISTORY":
                // setSessionHistory(message.sessions);
                break;
            case "ISSUE_ANALYTICS":
                setIssueAnalytics(message?.sessionIndices)
                break;
            case "SESSION_ID":
                bettingOpenRef.current = false;
                sessionIDRef.current = message?.sessionId;
                setSessionId(message?.sessionId);
                break;
            case "GAME_STARTED":
                break;
            case "BETS":
                resetBetRequest();
                if (message?.status) {
                    antMessage.destroy()
                    antMessage.success(message?.message || "Success")
                    setBetPlaced(true);
                }
                else {
                    antMessage.destroy()
                    antMessage.error(message?.message || "Error")
                }
                setBetLoading(false);
                setBetDetails(null);
                if (isValidWalletBalance(message?.userBalance)) setUserBalance(Number(message?.userBalance));
                break;
            case "BET_RESULT":
                if (isValidWalletBalance(message.userBalance)) setUserBalance(Number(message.userBalance));
                setBetResult(message?.result)
                break;
            case "GAME_ENDED":
                setWinningNumber(message?.winningNumber)
                // let latestHistory = {number:message?.winningNumber,createdAt:moment()};
                // setSessionHistory(prev=>[latestHistory,...prev]);

                break;
            case "BETTING_CLOSED":
                bettingOpenRef.current = false;
                break;
            case "NOTIFICATION":
                setNotification(message?.notification);
                break;
            case "COUNT_DOWN":
                bettingOpenRef.current = Number(message.remainingTime) > 5;
                sessionIDRef.current = message.session || message.sessionId;
                setSessionId(message?.session || message?.sessionId);
                setRemainingTime(message?.remainingTime);
                setCurrentPeriod(message?.period);
                break;

            case "ERROR":
                resetBetRequest();
                if (message?.message !== "You are already subscribed to this WebSocket connection.") {
                    antMessage.destroy()
                }
                setBetResult(null)
                setBetDetails(null);
                break;
            default:
                break;
        }
    };

    const subscribe = () => {
        if (socketConnetion) {
            subscribeToChannel(socket, "winGo", issue);
            //   changeIssue(socket, { gameType :"winGo", issue :issue });
        } else {
            console.log("Subscribe.");
            recoveryRef.current?.start();
        }
    };

    const unsubscribe = () => {
        if (socketConnetion) {
            unsubscribeFromChannel(socket);
        }
    };

    const placeBetHandler = ({ betAmount, betType, betValue, betSession }) => {
        if (betPendingRef.current) return false;
        if (!socketConnetion || socket?.readyState !== WebSocket.OPEN || !userDetails?.userId) {
            antMessage.error('Connection lost. Please wait for the game to reconnect.');
            resetBetRequest();
            return false;
        }
        if (!bettingOpenRef.current || !sessionIDRef.current) {
            antMessage.warning('Betting is closed. Please wait for the next round.');
            return false;
        }
        if (!Number.isFinite(betAmount) || betAmount <= 0 || betAmount > userBalance) {
            antMessage.error('Enter a valid bet within your available balance.');
            return false;
        }
        betPendingRef.current = true;
        setBetLoading(true);
        const sent = placeBet(socket, { userId: userDetails.userId,
            sessionId: sessionIDRef.current, betAmount, betType, betValue, betSession });
        if (!sent) { resetBetRequest(); return false; }
        betTimerRef.current = setTimeout(() => {
            resetBetRequest();
            antMessage.warning('Confirmation delayed. Check your bet history before trying again.');
        }, 12000);
        return true;
    };
    const changeIssueHandler = (issue) => {
        const newSearch = `?${new URLSearchParams({ issue, return_url: allParams?.return_url || '', currency: currencySymbol, token: userToken, user: allParams?.user })}`;

        // Navigate to the new path with query params
        navigate(`${newSearch}`);
        if (socketConnetion) {
            changeIssue(socket, { gameType: "winGo", issue: issue });
        } else {
            console.log("changeIssueHandler");
            verifyAndConnect();
        }
    };
    const handlerefreshBalance = () => {
        if (socketConnetion && userDetails?.userId) {
            refreshBalance(socket, { gameType: "winGo", userId: userDetails?.userId });
        } else {
            console.log("handlerefreshBalance");
            verifyAndConnect();
        }
    };
    useEffect(() => {
        if (allParams?.token && allParams?.user) {
            setUserToken(allParams?.token)
        } else {
            setSiteLoading(false)
            setUserDetails(false)
        }
    }, [allParams])


    // for scrolling notification section
    useEffect(() => {
        if (contentRef?.current?.scrollHeight <= 25) {
            document.querySelector(".noticeBar__container-body").style.paddingTop = "12px";
        } else {
            document.querySelector(".noticeBar__container-body").style.paddingTop = "2px";
        }
        const rowHeight = 18;
        const scrollDistance = rowHeight * 2;
        const scrollSpeed = 3000;
        const content = contentRef?.current;

        let totalHeight = content?.scrollHeight;

        const scrollUp = () => {
            if ((scrollPositionRef.current + (rowHeight * 3)) >= totalHeight) {
                setScrollPosition(0);
                content.style.transition = 'none';
                content.style.transform = `translateY(0)`;
                setTimeout(() => {
                    content.style.transition = 'transform 1s ease';
                }, 2000);
            } else {
                setScrollPosition(prevPosition => prevPosition + scrollDistance);
            }
        };

        const scrollInterval = setInterval(scrollUp, scrollSpeed + 100);
        return () => clearInterval(scrollInterval);
    }, [notification]);


    const getCurrencySymbol = (currencyCode) => {
        const formatter = new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: currencyCode
        });
        const formatted = formatter.format(1);
        return formatted.replace(/[0-9,.]/g, '').trim();
    };

    return (
        userDetails ?
            <div className="Wingo_game">
                <div className="stickyHeader flex align-items-center">
                    <div className="shLeft">
                        <Link to={allParams?.return_url || "/"}>
                            <img
                                src="/assets/images/left-arrow-svgrepo-com.svg"
                                alt=""
                                style={{ width: "25px" }}
                            />
                        </Link>
                    </div>
                    <div className="shCenter">
                        <img
                            src="/assets/images/wingo-logo.png"
                            alt="WinGo"
                            style={{
                                maxWidth: "120px",
                                display: "block",
                                margin: "0 auto 0",
                                maxHeight: "30px"
                            }}
                        />
                        <ProviderCredit header />
                    </div>
                    <div className="shRight">
                        <div
                            className="flex align-items-center"
                            style={{
                                gap: 10,
                                width: "max-content",
                                maxWidth: "100%",
                                marginLeft: "auto",
                                marginRight: "15px",
                            }}
                        >
                            <button style={{ background: "transparent", border: "none", outline: "none" }} onClick={() => setSoundOn(prev => !prev)}>
                                <img
                                    src={soundOn ? "/assets/images/voice-62dbf38c.png" : "/assets/images/noSound.png"}
                                    alt="support"
                                    style={{ width: "25px" }}
                                />
                            </button>
                        </div>
                    </div>
                </div>

                <div className="balanceSec">
                    <div className="balanceInner">
                        <p
                            style={{
                                fontWeight: 700,
                                textAlign: "center",
                                position: "relative",
                                fontSize: 18,
                                margin: 0,
                            }}
                        >
                            {currencySymbol}{" "}{parseFloat(userBalance).toFixed(2)}
                            <button
                                className="simpleButton"
                                onClick={handlerefreshBalance}
                                style={{ position: "absolute", top: 0, right: "25%" }}
                            >
                                <img
                                    src="/assets/images/refireshIcon-2bc1b49f.png"
                                    alt="refresh"
                                    style={{ width: 19, display: "block" }}
                                />
                            </button>
                        </p>
                        <div
                            className="flex justify-content-center align-items-center"
                            style={{ marginTop: 4, gap: 5, fontSize: 14, color: "#1E2637" }}
                        >
                            <svg
                                width="17px"
                                height="19px"
                                viewBox="-1.5 0 33 33"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlnsXlink="http://www.w3.org/1999/xlink"
                                xmlnssketch="http://www.bohemiancoding.com/sketch/ns"
                                fill="#000000"
                            >
                                <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                <g id="SVGRepo_iconCarrier">
                                    <title>wallet</title>
                                    <desc>Created with Sketch Beta.</desc>
                                    <defs></defs>
                                    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" sketchtype="MSPage">
                                        <g id="Icon-Set-Filled" sketchtype="MSLayerGroup" transform="translate(-259.000000, -776.000000)" fill={siteColor}>
                                            <path
                                                d="M283,799 L289,799 L289,797 L283,797 L283,799 Z M287,787 L259,787 L259,807 C259,808.104 259.896,809 261,809 L287,809 C288.104,809 289,808.104 289,807 L289,801 L282,801 C281.448,801 281,800.553 281,800 L281,796 C281,795.448 281.448,795 282,795 L289,795 L289,789 C289,787.896 288.104,787 287,787 L287,787 Z M287,778 C287,777.447 286.764,777.141 286.25,776.938 C285.854,776.781 285.469,776.875 285,777 L259,785 L287,785 L287,778 L287,778 Z"
                                                id="wallet"
                                                sketchtype="MSShapeGroup"
                                            />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                            <span style={{ marginTop: 4 }}>Wallet balance</span>
                        </div>
                    </div>

                    {/* notification */}
                    <div
                        className="notificationSec flex align-items-center"
                        style={{
                            gap: 3,
                            background: "#fff",
                            borderRadius: "100px",
                            margin: "18px 0",
                            padding: "0 10px",
                        }}
                    >
                        <svg
                            width="20px"
                            height="19px"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            id="sound-max"
                            className="icon glyph"
                            fill={siteColor}
                        >
                            <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                            <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                            <g id="SVGRepo_iconCarrier">
                                <path
                                    d="M18.36,19.36a1,1,0,0,1-.7-.29,1,1,0,0,1,0-1.41,8,8,0,0,0,0-11.32,1,1,0,0,1,1.41-1.41,10,10,0,0,1,0,14.14A1,1,0,0,1,18.36,19.36Z"
                                    style={{ fill: { siteColor } }}
                                />
                                <path
                                    d="M15.54,16.54a1,1,0,0,1-.71-.3,1,1,0,0,1,0-1.41,4,4,0,0,0,0-5.66,1,1,0,0,1,1.41-1.41,6,6,0,0,1,0,8.48A1,1,0,0,1,15.54,16.54Z"
                                    style={{ fill: { siteColor } }}
                                />
                                <path
                                    d="M11.38,4.08a1,1,0,0,0-1.09.21L6.59,8H4a2,2,0,0,0-2,2v4a2,2,0,0,0,2,2H6.59l3.7,3.71A1,1,0,0,0,11,20a.84.84,0,0,0,.38-.08A1,1,0,0,0,12,19V5A1,1,0,0,0,11.38,4.08Z"
                                    style={{ fill: { siteColor } }}
                                />
                            </g>
                        </svg>
                        <div className="noticeBar__container-body">
                            <div className="noticeBar__container-body-text" ref={contentRef} style={{
                                transform: `translateY(-${scrollPosition}px)`,
                                transition: 'transform 1s ease'
                            }}>
                                <p>{notification?.text || "No notifiations!"}</p>
                            </div>
                        </div>
                        <Link to={notification?.link || "/"} className="detailsButton" target="_blank">
                            <img src="/assets/images/redhomeN-36a3ba15.svg" alt="" style={{ width: 14, marginTop: 0 }} />
                            Detail
                        </Link>
                    </div>

                    {/* tabs button sec */}
                    <div className="tabsButtons">
                        <button className={issue === "issue1" || issue === undefined ? "active" : ""} onClick={() => { setGameTime("30S"); changeIssueHandler("issue1") }}>
                            <svg
                                width="40px"
                                height="40px"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="#fff"
                            >
                                <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                <g id="SVGRepo_iconCarrier">
                                    <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="1" />
                                    <path
                                        d="M12 8V12L14.5 14.5"
                                        stroke="#fff"
                                        strokeWidth="1"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                            <p>Win Go</p>
                            <p>30s</p>
                        </button>
                        <button className={issue === "issue2" ? "active" : ""} onClick={() => { setGameTime("1M"); changeIssueHandler("issue2") }}>
                            <svg
                                width="40px"
                                height="40px"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="#fff"
                            >
                                <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                <g id="SVGRepo_iconCarrier">
                                    <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="1" />
                                    <path
                                        d="M12 8V12L14.5 14.5"
                                        stroke="#fff"
                                        strokeWidth="1"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                            <p>Win go</p>
                            <p>1M</p>
                        </button>
                        <button className={issue === "issue3" ? "active" : ""} onClick={() => { setGameTime("3M"); changeIssueHandler("issue3") }}>
                            <svg
                                width="40px"
                                height="40px"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="#fff"
                            >
                                <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                <g id="SVGRepo_iconCarrier">
                                    <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="1" />
                                    <path
                                        d="M12 8V12L14.5 14.5"
                                        stroke="#fff"
                                        strokeWidth="1"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                            <p>Win go</p>
                            <p>3M</p>
                        </button>
                        <button className={issue === "issue4" ? "active" : ""} onClick={() => { setGameTime("5M"); changeIssueHandler("issue4") }}>
                            <svg
                                width="40px"
                                height="40px"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                stroke="#fff"
                            >
                                <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                <g id="SVGRepo_iconCarrier">
                                    <circle cx="12" cy="12" r="10" stroke="#fff" strokeWidth="1" />
                                    <path
                                        d="M12 8V12L14.5 14.5"
                                        stroke="#fff"
                                        strokeWidth="1"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                            </svg>
                            <p>Win go</p>
                            <p>5M</p>
                        </button>
                    </div>
                </div>

                {
                    gameTime ?
                        <GameTab
                            currencySymbol={currencySymbol}
                            gameTime={gameTime}
                            setShowAlert={setShowAlert}
                            setAlertMessage={setAlertMessage}
                            finalTime={remainingTime}
                            sessionHistory={sessionHistory}
                            setSessionHistory={setSessionHistory}
                            placeBetHandler={placeBetHandler}
                            betResult={betResult}
                            setBetResult={setBetResult}
                            sessionId={currentPeriod}
                            betDetails={betDetails}
                            setBetDetails={setBetDetails}
                            setBetLoading={setBetLoading}
                            betLoading={betLoading}
                            soundOn={soundOn}
                            howToPlayContent={howToPlayContent}
                            userDetails={userDetails}
                            userToken={userToken}
                            issueAnalytics={issueAnalytics}
                            issue={issue}
                            winningNumber={winningNumberRef?.current}
                            setWinningNumber={setWinningNumber}
                            setBetPlaced={setBetPlaced}
                            betPlaced={betPlacedRef?.current}
                        />
                        : null
                }
                <footer className="provider-credit-row"><ProviderCredit /></footer>
                {
                    siteLoading ?
                        <SiteLoading />
                        : null
                }
                {
                    showAlert ?
                        <ShowAlert alertMessage={alertMessage} setShowAlert={setShowAlert} />
                        : null
                }

            </div>
            :
            null

    );
}

const GameTab = ({
    finalTime,
    currencySymbol,
    gameTime,
    setShowAlert,
    setAlertMessage,
    placeBetHandler,
    sessionHistory,
    betResult,
    setBetResult,
    sessionId,
    betDetails,
    setBetDetails,
    betLoading,
    setBetLoading,
    soundOn,
    howToPlayContent,
    userDetails,
    userToken,
    issueAnalytics,
    issue,
    setSessionHistory,
    winningNumber,
    setWinningNumber,
    setBetPlaced,
    betPlaced,
}) => {

    const dataSource = sessionHistory;
    const chartData = sessionHistory
    const [currentDataType, setCurrentDataType] = useState("history");
    const [currentPage, setCurrentPage] = useState(1);
    const [currentBetRecordPage, setCurrentBetPage] = useState(1)
    const [currentChart, setCurrentChart] = useState(1);
    const [betRecords, setBetRecords] = useState([]);
    const [totalBetRecordPages, setTotalBetRecordsPages] = useState(1);
    const [betRecordPageSize, setbetRecordPageSize] = useState(10);
    const [pageSize, setPageSize] = useState(10);
    const [pageChartsize, setPageChartsize] = useState(10)
    const [totalPages, settotalPages] = useState(1);
    const [totalChartPages, setTotalChartPages] = useState(1);
    const [howToPlay, setHowToPlay] = useState(false);
    const [preSaleRule, setPreSaleRule] = useState(false);
    const [betTimeOver, setBetTimeOver] = useState(false);
    const [quantity, setQuantity] = useState(1);
    const [randomActive, setRandomActive] = useState(false)
    const [remainingTime, setRemainingTime] = useState(0)
    const [preSaleRuleHtml, setpreSaleRuleHtml] = useState(null)
    const [betPeriod, setBetPeriod] = useState(null);

    useEffect(() => {
        if (!betPlaced) {
            setBetPeriod(sessionId)
        }
    }, [sessionId, finalTime])

    const _fetchPreSaleRules = async (token) => {
        const response = await fetch(`https://wingo-backend.desiapi.com/api/winGo/fetchPreSaleRule`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `${token}`,
            },
        });
        const data = await response.json();
        if (data?.status) {
            setpreSaleRuleHtml(data?.content)
        }
    }
    useEffect(() => {
        if (!userToken) return;
        let active = true;
        const controller = new AbortController();
        fetchIssueSession(issue || "issue1", currentPage || 1, userToken, controller.signal).then(response => {
            if (!active) return;
            if (response?.status) {
                setSessionHistory(response.data);
                setPageChartsize(response.pagination?.limit || 10);
                setPageSize(response.pagination?.limit || 10);
                setTotalChartPages(response.pagination?.totalPages || 1);
                settotalPages(response.pagination?.totalPages || 1);
            } else {
                setSessionHistory([]);
                setPageChartsize(10);
                setPageSize(10);
                setTotalChartPages(1);
                settotalPages(1);
            }
        });
        return () => { active = false; controller.abort(); };
    }, [issue, currentPage, userToken, issueAnalytics]);

    useEffect(() => {
        if (userToken) {
            _fetchPreSaleRules(userToken)
        }
    }, [userToken])
    useEffect(() => {
        setRemainingTime(finalTime)
    }, [finalTime])

    useEffect(() => {
        if (remainingTime <= 0) return;

        const timer = setTimeout(() => {
            setRemainingTime(remainingTime - 1);
        }, 1000);

        return () => clearTimeout(timer);
    }, [remainingTime]);

    useEffect(() => {
        if (!userDetails?.userId || !userToken || currentDataType !== "myHistory") return;
        let active = true;
        const controller = new AbortController();
        fetchUserBets(userDetails.userId, currentBetRecordPage || 1, userToken, issue || "issue1", controller.signal).then(response => {
            if (!active) return;
            if (response?.status) {
                setBetRecords(response.data);
                setTotalBetRecordsPages(response.pagination?.totalPages || 1);
                setbetRecordPageSize(response.pagination?.limit || 10);
            } else {
                setBetRecords([]);
                setTotalBetRecordsPages(1);
                setbetRecordPageSize(10);
            }
        });
        return () => { active = false; controller.abort(); };
    }, [userDetails?.userId, currentBetRecordPage, userToken, currentDataType, issue, betResult]);


    const [audio] = useState({
        audio1: new Audio('/assets/audio/di1-0f3d86cb.mp3'),
        audio2: new Audio('/assets/audio/di2-ad9aa8fb.mp3'),
    });

    const isAudioLoading = () => {
        for (let key in audio) {
            const track = audio[key];

            if (track.readyState < 4) {
                return true;
            }
        }
        return false;
    };

    const playMusicForScenario = (gameStatus) => {
        const track = audio?.[gameStatus];
        if (track && soundOn) {
            track.play().catch((error) => {
                // console.error('Error playing audio:', error);
            });
        }
    };


    useEffect(() => {
        if (remainingTime <= 5) {
            setBetDetails(null);
            setBetTimeOver(true)
        } else {
            setBetTimeOver(false)
        }

        if (remainingTime <= 5 && remainingTime > 1) {
            if (isAudioLoading()) {
                return;
            }
            else {
                playMusicForScenario("audio1");
            }
        }
        if (remainingTime === 1) {
            if (isAudioLoading()) {
                return;
            }
            else {
                playMusicForScenario("audio2");
            }
        }
    }, [remainingTime])


    useEffect(() => {
        audio.audio1.load();
        audio.audio2.load();
    }, [audio]);

    const _changeQuantity = (value) => {
        if (value?.length > 0) {
            setQuantity(parseInt(value))
        }
        else {
            setQuantity("")
        }
    }
    const _nextButton = () => {
        if (currentPage < totalPages) {
            setCurrentChart(prev => prev + 1);
            setCurrentPage(prev => prev + 1);
        }
    }
    const _previousButton = () => {
        if (currentPage > 1) {
            setCurrentChart(prev => prev - 1);
            setCurrentPage(prev => prev - 1);
        }
    }
    const _previousChart = () => {
        if (currentChart > 1) {
            setCurrentChart(prev => prev - 1);
            setCurrentPage(prev => prev - 1);
        }
    }
    const _nextChart = () => {
        if (currentChart < totalChartPages) {
            setCurrentChart(prev => prev + 1);
            setCurrentPage(prev => prev + 1);
        }
    }
    const _prevRecordPage = () => {
        if (currentBetRecordPage > 1) {
            setCurrentBetPage((prev) => --prev)
        }
    }
    const _nextRecordPage = () => {
        if (currentBetRecordPage < totalBetRecordPages) {
            setCurrentBetPage((prev) => ++prev)
        }
    }
    const _copyText = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setAlertMessage("Copy successful")
            setShowAlert(true)
        }).catch(err => {
            console.error('Failed to copy text: ', err);
        });
    }

    const _setBetDetails = (betType, betValue, betColor) => {
        setBetDetails({
            betType, betValue, betColor
        })
    }

    const _randomBet = () => {
        let randomNumber = Math.floor(Math.random() * 10);
        setRandomActive(true)
        setTimeout(() => {
            if (!betTimeOver) {
                _setBetDetails("straight", randomNumber, randomNumber % 2 === 0 ? "red" : "green")
            }
            setRandomActive(false);
        }, 4000);

    }

    const columns = [
        {
            title: 'Period',
            dataIndex: 'period',
            key: 'period',
        },
        {
            title: 'Number',
            dataIndex: 'number',
            key: 'number',
            render: (number, record, index) =>
                <span key={record?._id || index} className={`tableNumber ${number === 0 ? "violet" : number === 5 ? "greenMix" : number % 2 === 0 ? "red" : "green"}`}>
                    {number}
                </span>
        },
        {
            title: 'Big/Small',
            dataIndex: 'number',
            key: 'bigSmall',
            render: (number) => number < 5 ? "Small" : "Big"
        },
        {
            title: 'Color',
            dataIndex: 'number',
            key: 'color',
            render: (number, record, index) => (
                (number === 5 || number === 0) ?

                    <div key={record?._id || index} style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        <span
                            className="colorDot"
                            style={{
                                display: 'inline-block',
                                width: 14,
                                height: 14,
                                borderRadius: '50%',
                                backgroundColor: number === 5 ? "#18B660" : "#f95959",
                            }}
                        />
                        <span
                            className="colorDot"
                            style={{
                                display: 'inline-block',
                                width: 14,
                                height: 14,
                                borderRadius: '50%',
                                backgroundColor: "#c86eff",
                            }}
                        />
                    </div>
                    :
                    <span key={record?._id || index}
                        className="colorDot"
                        style={{
                            display: 'inline-block',
                            width: 14,
                            height: 14,
                            borderRadius: '50%',
                            backgroundColor: number % 2 === 0 ? "#f95959" : '#18B660',
                        }}
                    />
            ),
        },
    ];

    const items = betRecords?.length > 0 && betRecords.map((item, index) =>
    (
        {
            key: item?._id || index,
            label: <div key={item?._id || index} className="detailsHeader">
                <div className="dshLeft">
                    <div className=
                        {`dshLeftNumber ${item?.betValue === 0 ? "multiColor" : item?.betValue === 5 ? "multiColorNew" : item?.betValue % 2 === 0 ? "red" : item?.betValue % 2 === 1 ? "green" : item?.betValue}`}
                    >
                        {
                            item?.betType === "bigSmall" ?
                                <span style={{ color: "#fff" }}>{item.betValue}</span>
                                :
                                item?.betType === "straight" ?
                                    item?.betValue
                                    : ""
                        }
                    </div>
                    <div>
                        <p>{item?.sessionId?.period}</p>
                        <span>{moment(item?.createdAt).format('YYYY-MM-DD HH:mm:ss')}</span>
                    </div>
                </div>
                {
                    item?.status !== "pending" ?
                        <div className={`dshRight `}>
                            <span className={item?.win ? "green" : "red"}>{item?.win ? "Succeed" : "Failed"}</span>
                            <p className={item?.win ? "green" : "red"}>{item?.win ? "+ " : "- "}{currencySymbol + " "}{item?.win ? parseFloat(item?.winAmount).toFixed(2) : Number(item?.purchaseAmount ?? item?.betAmount).toFixed(2)}</p>
                        </div>
                        : null
                }
            </div>,
            children:
                <div key={index} className="detailsBody">
                    <h4>Details</h4>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Order number</span>
                        </div>
                        <div className="dblRight" >
                            <span >{item?.order} </span>
                            <span><CopyOutlined style={{ color: "#768096" }} onClick={() => _copyText(item?.order)} /></span>
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Period</span>
                        </div>
                        <div className="dblRight">
                            <span>{item?.sessionId?.period} </span>
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Purchase amount</span>
                        </div>
                        <div className="dblRight">
                            <span>{currencySymbol + " "}{Number(item?.purchaseAmount ?? item?.betAmount).toFixed(2)}</span>
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft"><span>Platform Fee ({item?.platformFeePercentage ?? 0}%)</span></div>
                        <div className="dblRight"><span>{currencySymbol + " "}{Number(item?.platformFeeAmount ?? 0).toFixed(2)}</span></div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft"><span>Bet amount</span></div>
                        <div className="dblRight"><span>{currencySymbol + " "}{Number(item?.betAmount).toFixed(2)}</span></div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Select</span>
                        </div>
                        <div className="dblRight">
                            <span style={{ textTransform: "capitalize" }}>{item?.betValue}</span>
                        </div>
                    </div>
                    {/* <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Amount after tax</span>
                        </div>
                        <div className="dblRight">
                            <span className={item?.win ? "green":"red"}>{currencySymbol}--</span>
                        </div>
                    </div> */}
                    {/* <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Tax</span>
                        </div>
                        <div className="dblRight">
                            <span>{currencySymbol}--</span>
                        </div>
                    </div> */}
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span >Result</span>
                        </div>
                        <div className="dblRight result">
                            {
                                item?.status !== "pending" ?
                                    <>
                                        <span style={{ textTransform: "capitalize" }}>{item?.sessionId?.number}</span>
                                        {
                                            item?.sessionId?.number === 0 ?
                                                <>
                                                    <span className="red">
                                                        Red
                                                    </span>
                                                    <span>+</span>
                                                    <span className="violet">
                                                        Violet
                                                    </span>
                                                </>
                                                : item?.sessionId?.number === 5 ?
                                                    <>
                                                        <span className="green">
                                                            Green
                                                        </span>
                                                        <span>+</span>
                                                        <span className="violet">
                                                            Violet
                                                        </span>
                                                    </>
                                                    :
                                                    <span className={item?.sessionId?.number % 2 === 0 ? "red" : item?.sessionId?.number % 2 === 1 ? "green" : item?.sessionId?.number}>
                                                        {item?.sessionId?.number % 2 === 0 ? "Red" : item?.sessionId?.number % 2 === 1 ? "Green" : item?.sessionId?.number}
                                                    </span>

                                        }
                                        <span className={item?.sessionId?.number >= 5 ? "orange" : "blue"}>{item?.sessionId?.number >= 5 ? "Big" : "Small"}</span>
                                    </>
                                    : <span>--</span>
                            }
                        </div>
                    </div>
                    {/* <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Select</span>
                        </div>
                        <div className="dblRight">
                            <span>--</span>
                        </div>
                    </div> */}
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Status</span>
                        </div>
                        <div className="dblRight">
                            {
                                item?.status !== "pending" ?
                                    <span className={item?.win ? "green" : "red"}>{item?.win ? "Succeed" : "Failed"}</span>
                                    : <span>Pending</span>
                            }
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Win/Lose</span>
                        </div>
                        <div className="dblRight">
                            {
                                item?.status !== "pending" ?
                                    <span className={item?.win ? "green" : "red"}>{item?.win ? "+ " : "- "}{currencySymbol + " "}{item?.win ? parseFloat(item?.winAmount).toFixed(2) : Number(item?.purchaseAmount ?? item?.betAmount).toFixed(2)}</span>
                                    : <span>--</span>

                            }
                        </div>
                    </div>
                    <div className="detailsBodyList">
                        <div className="dblLeft">
                            <span>Order Time</span>
                        </div>
                        <div className="dblRight">
                            <span>{moment(item?.createdAt).format('YYYY-MM-DD HH:mm:ss')}</span>
                        </div>
                    </div>

                </div>,
        }
    )
    )
    return (
        <>
            <button id="dummyButton" style={{ display: "none" }}></button>
            <div className="ticketSection" >
                <div className="tsLeft">
                    <button onClick={() => setHowToPlay(true)}>
                        <svg data-v-3e4c6499="" xmlns="http://www.w3.org/2000/svg" width="19px" viewBox="0 0 36 36" fill="none"><path data-v-3e4c6499="" d="M23.67 3H12.33C6.66 3 5.25 4.515 5.25 10.56V27.45C5.25 31.44 7.44 32.385 10.095 29.535L10.11 29.52C11.34 28.215 13.215 28.32 14.28 29.745L15.795 31.77C17.01 33.375 18.975 33.375 20.19 31.77L21.705 29.745C22.785 28.305 24.66 28.2 25.89 29.52C28.56 32.37 30.735 31.425 30.735 27.435V10.56C30.75 4.515 29.34 3 23.67 3ZM11.67 18C10.845 18 10.17 17.325 10.17 16.5C10.17 15.675 10.845 15 11.67 15C12.495 15 13.17 15.675 13.17 16.5C13.17 17.325 12.495 18 11.67 18ZM11.67 12C10.845 12 10.17 11.325 10.17 10.5C10.17 9.675 10.845 9 11.67 9C12.495 9 13.17 9.675 13.17 10.5C13.17 11.325 12.495 12 11.67 12ZM24.345 17.625H16.095C15.48 17.625 14.97 17.115 14.97 16.5C14.97 15.885 15.48 15.375 16.095 15.375H24.345C24.96 15.375 25.47 15.885 25.47 16.5C25.47 17.115 24.96 17.625 24.345 17.625ZM24.345 11.625H16.095C15.48 11.625 14.97 11.115 14.97 10.5C14.97 9.885 15.48 9.375 16.095 9.375H24.345C24.96 9.375 25.47 9.885 25.47 10.5C25.47 11.115 24.96 11.625 24.345 11.625Z" fill="currentColor"></path></svg>
                        How to play
                    </button>
                    <p style={{ margin: "0 0 7px 3px", fontSize: "13px", color: "#fff", textTransform: "capitalize" }}>Win Go {gameTime}</p>
                    <div className="lastwinner">
                        {
                            sessionHistory?.length > 0 ?
                                sessionHistory.map((session, index) => {
                                    if (index < 5) {
                                        return (
                                            <div key={session?._id}>
                                                <img src={`/assets/images/winner-${session?.number}.png`} alt="" />
                                            </div>
                                        )
                                    }
                                })
                                : null
                        }
                    </div>
                </div>
                <div className="tsRight">
                    <p style={{ fontSize: "13px", fontWeight: 700, color: "#fff", textAlign: "right", margin: 0 }}>Time remaining</p>
                    <div className="trTime">
                        <div>{Math.floor((Math.floor(remainingTime / 60)) / 10) || 0}</div>
                        <div>{Math.floor(Math.floor(remainingTime / 60)) % 10 || 0}</div>
                        <div>:</div>
                        <div>{Math.floor((Math.floor(remainingTime % 60)) / 10) || 0}</div>
                        <div>{Math.floor(Math.floor(remainingTime % 60)) % 10 || 0}</div>
                    </div>
                    <div className="userId">
                        {sessionId}
                    </div>
                </div>

            </div>

            <div className="battingSec">
                <div className="colorButtons">
                    <button className="green" onClick={() => _setBetDetails("color", "green", "green")}>Green</button>
                    <button className="violet" onClick={() => _setBetDetails("color", "violet", "violet")}> Violet</button>
                    <button className="red" onClick={() => _setBetDetails("color", "red", "red")}>Red</button>
                </div>
                <div className={`betTickets ${randomActive ? "active" : ""}`}>
                    <div onClick={() => _setBetDetails("straight", 0, "violet")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>
                                    <span>0</span>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div onClick={() => _setBetDetails("straight", 1, "green")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>1</span>
                            </span>
                        </div>
                    </div>
                    <div onClick={() => _setBetDetails("straight", 2, "red")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>2</span>
                            </span>
                        </div>
                    </div>
                    <div onClick={() => _setBetDetails("straight", 3, "green")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>3</span>
                            </span>
                        </div>
                    </div>
                    <div onClick={() => _setBetDetails("straight", 4, "red")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>4</span>
                            </span>
                        </div>
                    </div>
                    <div onClick={() => _setBetDetails("straight", 5, "violet")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>
                                    <span>5</span>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div onClick={() => _setBetDetails("straight", 6, "red")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>6</span>
                            </span>
                        </div>
                    </div>
                    <div onClick={() => _setBetDetails("straight", 7, "green")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>7</span>
                            </span>
                        </div>
                    </div>
                    <div onClick={() => _setBetDetails("straight", 8, "red")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>8</span>
                            </span>
                        </div>
                    </div>
                    <div onClick={() => _setBetDetails("straight", 9, "green")}>
                        <div className="ticketOuter">
                            <span className="betticket">
                                <span>9</span>
                            </span>
                        </div>
                    </div>
                </div>
                <div className="betMultiplier">
                    <button className="random" onClick={_randomBet}>Random</button>
                    <button className={quantity === 1 ? "active" : ""} onClick={(e) => _changeQuantity("1")}>X1</button>
                    <button className={quantity === 5 ? "active" : ""} onClick={(e) => _changeQuantity("5")}>X5</button>
                    <button className={quantity === 10 ? "active" : ""} onClick={(e) => _changeQuantity("10")}>X10</button>
                    <button className={quantity === 20 ? "active" : ""} onClick={(e) => _changeQuantity("20")}>X20</button>
                    <button className={quantity === 50 ? "active" : ""} onClick={(e) => _changeQuantity("50")}>X50</button>
                    <button className={quantity === 100 ? "active" : ""} onClick={(e) => _changeQuantity("100")}>X100</button>
                </div>
                <div className="bigSmallButtons">
                    <button className="bsBig" onClick={() => _setBetDetails("bigSmall", "big", "big")}>Big</button>
                    <button className="bsSmall" onClick={() => _setBetDetails("bigSmall", "small", "small")}>Small</button>
                </div>
                {
                    betTimeOver ?
                        <div className="battingOverlay">
                            <div className="boLeft">{Math.floor((Math.floor(remainingTime % 60)) / 10) || 0}</div>
                            <div className="boRight">{Math.floor(Math.floor(remainingTime % 60)) % 10 || 0}</div>
                        </div>
                        : null
                }
            </div>

            <div className="gameData customAccordion">
                <div className="gdButtons">
                    <button onClick={() => setCurrentDataType("history")} className={currentDataType === "history" ? "active" : ""}>Game history</button>
                    <button onClick={() => setCurrentDataType("chart")} className={currentDataType === "chart" ? "active" : ""}>Chart</button>
                    <button onClick={() => setCurrentDataType("myHistory")} className={currentDataType === "myHistory" ? "active" : ""}>My history</button>
                </div>
                {
                    currentDataType === "history" ?
                        <div>
                            <Table
                                dataSource={dataSource}
                                columns={columns}
                                pagination={false}
                                bordered={false}
                            />
                            <div className="pagination">
                                <button className={`previousButton ${currentPage > 1 ? "active" : ""}`} onClick={_previousButton} >
                                    <svg
                                        fill={currentPage > 1 ? "#fff" : "#7682a2"}
                                        stroke={currentPage > 1 ? "#fff" : "#7682a2"}
                                        version="1.1"
                                        id="Layer_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        width="22px"
                                        viewBox="0 0 100.00 100.00"
                                        enableBackground="new 0 0 100 100"
                                        xmlSpace="preserve"
                                        strokeWidth="3.5"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                        <g id="SVGRepo_iconCarrier">
                                            <g>
                                                <path
                                                    d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                                />
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                                <span style={{ fontSize: "13px", color: "#768096" }}>{currentPage}/{totalPages}</span>
                                <button className={`nextButton ${currentPage < totalPages ? "active" : ""}`} onClick={_nextButton}>
                                    <svg
                                        fill={currentPage < totalPages ? "#fff" : "#7682a2"}
                                        stroke={currentPage < totalPages ? "#fff" : "#7682a2"}
                                        version="1.1"
                                        id="Layer_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        width="22px"
                                        viewBox="0 0 100.00 100.00"
                                        enableBackground="new 0 0 100 100"
                                        xmlSpace="preserve"
                                        strokeWidth="3.5"
                                        transform="rotate(180)"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                        <g id="SVGRepo_iconCarrier">
                                            <g>
                                                <path
                                                    d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                                />
                                            </g>
                                        </g>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        : null
                }
                {
                    currentDataType === "chart" ?
                        <div className="chartSec">
                            <div className="csHeader">
                                <div className="cshLeft">Period</div>
                                <div className="cshRight">Number</div>
                            </div>
                            <div className="statistic" style={{ background: "#fff", marginBottom: "20px" }}>
                                <p>Statistic (last 100 Periods)</p>
                                <div className="stTable winningNumber">
                                    <div className="stLeft">Winning number</div>
                                    <div className="stRight">
                                        <span>0</span>
                                        <span>1</span>
                                        <span>2</span>
                                        <span>3</span>
                                        <span>4</span>
                                        <span>5</span>
                                        <span>6</span>
                                        <span>7</span>
                                        <span>8</span>
                                        <span>9</span>
                                    </div>
                                </div>
                                <div className="stTable">
                                    <div className="stLeft">Missing</div>
                                    <div className="stRight">
                                        {
                                            issueAnalytics?.missing?.[0] ?
                                                Object.entries(issueAnalytics?.missing).map(([key, value]) => (
                                                    <span key={key}>{value}</span>
                                                ))
                                                : null
                                        }
                                    </div>
                                </div>
                                <div className="stTable">
                                    <div className="stLeft">Avg missing</div>
                                    <div className="stRight">
                                        {
                                            issueAnalytics?.avgMissing?.[0] > 0 ?
                                                Object.entries(issueAnalytics?.avgMissing).map(([key, value]) => (
                                                    <span key={key}>{value}</span>
                                                ))
                                                : null
                                        }
                                    </div>
                                </div>
                                <div className="stTable">
                                    <div className="stLeft">Frequency</div>
                                    <div className="stRight">
                                        {
                                            issueAnalytics?.frequency?.[0] > 0 ?
                                                Object.entries(issueAnalytics?.frequency).map(([key, value]) => (
                                                    <span key={key}>{value}</span>
                                                ))
                                                : null
                                        }
                                    </div>
                                </div>
                                <div className="stTable">
                                    <div className="stLeft">Max consecutive</div>
                                    <div className="stRight">
                                        {
                                            issueAnalytics?.maxConsecutive?.[0] > 0 ?
                                                Object.entries(issueAnalytics?.maxConsecutive).map(([key, value]) => (
                                                    <span key={key}>{value}</span>
                                                ))
                                                : null
                                        }
                                    </div>
                                </div>

                                <div className="lastWinnerTableContainer">
                                    {
                                        chartData?.length > 0 ?
                                            chartData.map((chart, index, array) => {
                                                let points = array?.length > index + 1 ? [chart?.number + 1, array[index + 1]?.number + 1] : null
                                                return (
                                                    <div className="lastWinnerTable" key={index}>
                                                        <div className="lwstLeft">{chart?.period}</div>
                                                        <div className="lwtMedium">
                                                            <div className="lwtMediumInner">
                                                                {
                                                                    [0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((num, index) => (
                                                                        <span key={index} className={num === chart?.number ? "active" : ""}>{num}</span>
                                                                    ))

                                                                }
                                                            </div>
                                                            {
                                                                points ?
                                                                    <CanvasComponent points={points} index={index + (pageChartsize * currentChart)} />
                                                                    : null
                                                            }
                                                        </div>
                                                        <div className={`lwtRight ${chart?.number < 5 ? "blue" : ""}`}>
                                                            <span>{chart?.number >= 5 ? "B" : "S"}</span>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            : null
                                    }
                                </div>


                            </div>
                            <div className="pagination">
                                <button className={`previousButton ${currentChart > 1 ? "active" : ""}`} onClick={_previousChart} >
                                    <svg
                                        fill={currentChart > 1 ? "#fff" : "#7682a2"}
                                        stroke={currentChart > 1 ? "#fff" : "#7682a2"}
                                        version="1.1"
                                        id="Layer_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        width="22px"
                                        viewBox="0 0 100.00 100.00"
                                        enableBackground="new 0 0 100 100"
                                        xmlSpace="preserve"
                                        strokeWidth="3.5"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                        <g id="SVGRepo_iconCarrier">
                                            <g>
                                                <path
                                                    d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                                />
                                            </g>
                                        </g>
                                    </svg> </button>
                                <span style={{ fontSize: "13px", color: "#768096" }}>{currentChart}/{totalChartPages}</span>
                                <button className={`nextButton ${currentChart < totalChartPages ? "active" : ""}`} onClick={_nextChart}>
                                    <svg
                                        fill={currentChart < totalPages ? "#fff" : "#7682a2"}
                                        stroke={currentChart < totalPages ? "#fff" : "#7682a2"}
                                        version="1.1"
                                        id="Layer_1"
                                        xmlns="http://www.w3.org/2000/svg"
                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                        width="22px"
                                        viewBox="0 0 100.00 100.00"
                                        enableBackground="new 0 0 100 100"
                                        xmlSpace="preserve"
                                        strokeWidth="3.5"
                                        transform="rotate(180)"
                                    >
                                        <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                        <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                        <g id="SVGRepo_iconCarrier">
                                            <g>
                                                <path
                                                    d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                                />
                                            </g>
                                        </g>
                                    </svg> </button>
                            </div>
                        </div>
                        : null
                }
                {
                    currentDataType === "myHistory" ?
                        <div className="historyDetails">
                            <div className="historydetailsButton">
                                <Link to={`/bet-records/${window.location.search}`}>Detail <img src="/assets/images/right-arrow-next-svgrepo-com.svg" alt="" style={{ display: "block", width: "17px" }} /></Link>
                            </div>
                            {
                                betRecords?.length > 0 ?
                                    <>
                                        <Collapse items={items} expandIcon={() => null} />
                                        <div className="pagination">
                                            <button className={`previousButton ${currentBetRecordPage > 1 ? "active" : ""}`} onClick={_prevRecordPage} >
                                                <svg
                                                    fill={currentBetRecordPage > 1 ? "#fff" : "#7682a2"}
                                                    stroke={currentBetRecordPage > 1 ? "#fff" : "#7682a2"}
                                                    version="1.1"
                                                    id="Layer_1"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    width="22px"
                                                    viewBox="0 0 100.00 100.00"
                                                    enableBackground="new 0 0 100 100"
                                                    xmlSpace="preserve"
                                                    strokeWidth="3.5"
                                                >
                                                    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                                    <g id="SVGRepo_iconCarrier">
                                                        <g>
                                                            <path
                                                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                                            />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </button>
                                            <span style={{ fontSize: "13px", color: "#768096" }}>{currentBetRecordPage}/{totalBetRecordPages}</span>
                                            <button className={`nextButton ${currentBetRecordPage < totalBetRecordPages ? "active" : ""}`} onClick={_nextRecordPage}>
                                                <svg
                                                    fill={currentBetRecordPage < totalBetRecordPages ? "#fff" : "#7682a2"}
                                                    stroke={currentBetRecordPage < totalBetRecordPages ? "#fff" : "#7682a2"}
                                                    version="1.1"
                                                    id="Layer_1"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                                    width="22px"
                                                    viewBox="0 0 100.00 100.00"
                                                    enableBackground="new 0 0 100 100"
                                                    xmlSpace="preserve"
                                                    strokeWidth="3.5"
                                                    transform="rotate(180)"
                                                >
                                                    <g id="SVGRepo_bgCarrier" strokeWidth="0" />
                                                    <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round" />
                                                    <g id="SVGRepo_iconCarrier">
                                                        <g>
                                                            <path
                                                                d="M33.934,54.458l30.822,27.938c0.383,0.348,0.864,0.519,1.344,0.519c0.545,0,1.087-0.222,1.482-0.657 c0.741-0.818,0.68-2.083-0.139-2.824L37.801,52.564L64.67,22.921c0.742-0.818,0.68-2.083-0.139-2.824 c-0.817-0.742-2.082-0.679-2.824,0.139L33.768,51.059c-0.439,0.485-0.59,1.126-0.475,1.723 C33.234,53.39,33.446,54.017,33.934,54.458z"
                                                            />
                                                        </g>
                                                    </g>
                                                </svg>
                                            </button>
                                        </div>
                                    </>
                                    : <div style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        height: "100px",
                                        justifyItems: "center",
                                        color: "#768096",
                                        fontSize: "16px",
                                    }}>
                                        No data
                                    </div>
                            }
                        </div>
                        : null
                }
            </div>
            {
                (betDetails && !betTimeOver) ?
                    <SelectBet
                        currencySymbol={currencySymbol}
                        gameTime={gameTime}
                        setBetDetails={setBetDetails}
                        betDetails={betDetails}
                        setPreSaleRule={setPreSaleRule}
                        placeBetHandler={placeBetHandler}
                        _changeQuantity={_changeQuantity}
                        quantity={quantity}
                        setQuantity={setQuantity}
                        betLoading={betLoading}
                        setBetLoading={setBetLoading}
                    />
                    : null
            }
            {
                howToPlay ?
                    <HowToPlay howToPlay={howToPlay} setHowToPlay={setHowToPlay} howToPlayContent={howToPlayContent} />
                    : null
            }
            {
                preSaleRule ?
                    <PreSaleRule setPreSaleRule={setPreSaleRule} preSaleRuleHtml={preSaleRuleHtml} />
                    : null
            }
            {
                betResult?.status === "loss" ?
                    <LosePopup winningNumber={winningNumber} setWinningNumber={setWinningNumber} gameTime={gameTime} sessionId={betPeriod} betResult={betResult} setBetResult={setBetResult} currencySymbol={currencySymbol} setBetPlaced={setBetPlaced} />
                    : null
            }
            {
                betResult?.status === "win" ?
                    <WinPopup gameTime={gameTime} sessionId={betPeriod} betResult={betResult} setBetResult={setBetResult} currencySymbol={currencySymbol} setBetPlaced={setBetPlaced} />
                    : null
            }
        </>
    )
}

const SelectBet = ({
    gameTime,
    placeBetHandler,
    setPreSaleRule,
    currencySymbol,
    betDetails,
    setBetDetails,
    quantity,
    setQuantity,
    _changeQuantity,
    betLoading,
    setBetLoading,
}) => {
    const [checkedAgreement, setcheckedAgreement] = useState(true)
    const [checkedBalance, setcheckedBalance] = useState(1)


    useEffect(() => {
        setBetLoading(false)
    }, [])

    const _increaseQuantity = () => {
        if (quantity >= 1) {
            setQuantity(quantity + 1)
        }
        else {
            setQuantity(1)
        }
    }
    const _decreaseQuantity = () => {
        if (quantity > 1) {
            setQuantity(quantity - 1)
        }
        else {
            setQuantity(0)
        }
    }

    const _placeBet = () => {
        if (!checkedAgreement) {
            message.error("Please check the box to agree to the pre-sale rules.");
            return;
        }
        let BetSession = gameTime === "30S" ? 1 : gameTime === "1M" ? 2 : gameTime === "3M" ? 3 : gameTime === "5M" ? 4 : null;
        let payload = {
            betAmount: (quantity > 0 && checkedBalance) ? parseFloat(quantity * checkedBalance) : 0,
            betType: betDetails?.betType,
            betValue: betDetails?.betValue,
            betSession: BetSession
        }
        placeBetHandler(payload)
    }
    return (
        <div className={`selectBetModal ${betDetails?.betColor}`}>
            <div className="sbmInner">
                <div className={`sbmHeader ${betDetails?.betValue === 0 ? "multiColor" : betDetails?.betValue === 5 ? "multiColorNew" : ""}`}>
                    <h3>Win Go {gameTime}</h3>
                    <div className="selectedTitle">
                        <span>Select</span>
                        <span>{betDetails?.betValue}</span>
                    </div>
                </div>
                <div className="sbmBalance">
                    <p>Balance</p>
                    <div className="sbmBalanceRight">
                        <button className={checkedBalance === 1 ? "" : "active"} onClick={() => setcheckedBalance(1)}>1</button>
                        <button className={checkedBalance === 10 ? "" : "active"} onClick={() => setcheckedBalance(10)}>10</button>
                        <button className={checkedBalance === 100 ? "" : "active"} onClick={() => setcheckedBalance(100)}>100</button>
                        <button className={checkedBalance === 1000 ? "" : "active"} onClick={() => setcheckedBalance(1000)}>1000</button>
                    </div>
                </div>
                <div className="sbmBalance sbmQuantity">
                    <p>Quantity</p>
                    <div className="sbmBalanceRight">
                        <button className={quantity > 0 ? "active" : ""} onClick={_decreaseQuantity}>-</button>
                        <input type="number" value={quantity} onChange={(e) => _changeQuantity(e.target.value)} />
                        <button className="active" onClick={_increaseQuantity}>+</button>
                    </div>
                </div>
                <div className="sbmBalance ">
                    <p></p>
                    <div className="sbmBalanceRight">
                        <button className={quantity === 1 ? "" : "active"} onClick={(e) => _changeQuantity("1")}>X1</button>
                        <button className={quantity === 5 ? "" : "active"} onClick={(e) => _changeQuantity("5")}>X5</button>
                        <button className={quantity === 10 ? "" : "active"} onClick={(e) => _changeQuantity("10")}>X10</button>
                        <button className={quantity === 20 ? "" : "active"} onClick={(e) => _changeQuantity("20")}>X20</button>
                        <button className={quantity === 50 ? "" : "active"} onClick={(e) => _changeQuantity("50")}>X50</button>
                        <button className={quantity === 100 ? "" : "active"} onClick={(e) => _changeQuantity("100")}>X100</button>
                    </div>
                </div>
                <div className="agreeRules">
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span className={`checkAgreement ${checkedAgreement ? "active" : ""}`} onClick={() => setcheckedAgreement(prev => !prev)}></span>
                        <span style={{ color: "#1e2637", fontSize: "13px", marginLeft: "5px" }}>I agree</span>
                    </div>
                    <button onClick={() => setPreSaleRule(true)}>《Pre-sale rules》</button>
                </div>
                <div className="sbmFooter">
                    <button onClick={() => setBetDetails(null)}>Cancel</button>
                    <Button style={{
                        width: "70%",
                        color: "#fff",
                    }}
                        className="betPlaceButton"
                        onClick={_placeBet}
                        loading={betLoading}
                    >
                        Total amount {currencySymbol + " "}{(quantity > 0 && checkedBalance) ? parseFloat(quantity * checkedBalance) : 0}
                    </Button>
                </div>
            </div>
        </div>
    )
}

const CanvasComponent = ({ points, index }) => {

    useEffect(() => {
        const canvas = document.getElementById("canvas-" + index + 1);
        const ctx = canvas.getContext('2d');
        const width = canvas.width;
        const height = canvas.height;
        const startPoint = (points[0] * 10 / 100) * width - 13;
        const endPoint = (points[1] * 10 / 100) * width - 13;

        ctx.clearRect(0, 0, width, height);
        ctx.beginPath();
        ctx.moveTo(startPoint, 0);
        ctx.lineTo(endPoint, height);
        ctx.stroke();
        return () => {
            ctx.clearRect(0, 0, width, height); // Clear the canvas on cleanup
        };
    }, [points, index]);
    return (
        <canvas
            key={index}
            id={"canvas-" + index + 1}
            style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                left: 0,
                top: "50%"
            }}
        ></canvas>
    )
}

const HowToPlay = ({ setHowToPlay, howToPlayContent }) => {
    return (
        <div className="ruleModel">
            <div className="ruleModelInner">
                <div className="rmiHeader">
                    How to play
                </div>
                <div className="rmiBody">
                    <div className="rmiBodyInner" dangerouslySetInnerHTML={{ __html: howToPlayContent }}></div>
                </div>
                <div className="rmiFooter">
                    <button onClick={() => setHowToPlay(false)}>Close</button>
                </div>
            </div>
        </div>
    )
}
const PreSaleRule = ({ setPreSaleRule, preSaleRuleHtml }) => {
    return (
        <div className="ruleModel preSaleRuleModal">
            <div className="ruleModelInner">
                <div className="rmiHeader">
                    《Pre-sale rules》
                </div>
                <div className="rmiBody">
                    <div className="rmiBodyInner" dangerouslySetInnerHTML={{ __html: preSaleRuleHtml }}>

                    </div>
                </div>
                <div className="rmiFooter">
                    <button onClick={() => setPreSaleRule(false)}>I know</button>
                </div>
            </div>
        </div>
    )
}

const SiteLoading = () => {

    return (
        <div className="siteLoadingOuter">
            <div className="siteLoading">
                <Spin indicator={<LoadingOutlined spin style={{ color: "#fff", fontSize: "30px" }} />} />
            </div>
        </div>
    )
}

const ShowAlert = ({ alertMessage, setShowAlert }) => {
    useEffect(() => {
        setTimeout(() => {
            setShowAlert(false)
        }, 2000);
    }, [])
    return (
        alertMessage === "Copy successful" ?
            <div className="siteLoading showAlertMessage copyAlert">
                <span><CheckOutlined style={{ color: "#fff", fontSize: "30px" }} /></span>
                <p>Copy successful</p>
            </div>
            :
            <div className="siteLoading showAlertMessage">
                <p>{alertMessage || "Refresh Successfully"}</p>
            </div>
    )
}
const LosePopup = ({ betResult, setBetResult, currencySymbol, gameTime, sessionId, setWinningNumber, winningNumber, setBetPlaced }) => {
    const [cookies, setCookies, removeCookies] = useCookies();

    const [remainSeconds, setremainSeconds] = useState(3)

    const _toggleAutoClose = () => {
        if (cookies?.autoClose) {
            removeCookies("autoClose", { path: "/" })
        }
        else {
            setCookies("autoClose", true, { path: "/" })
        }
    }

    useEffect(() => {
        if (remainSeconds === 0) {
            setBetResult(null);
            setBetPlaced(false)
            setWinningNumber(null);
        }
    }, [remainSeconds])
    useEffect(() => {
        if (cookies?.autoClose === undefined) return;

        const interval = setInterval(() => {
            if (remainSeconds <= 0) {
                setBetResult(null)
                setBetPlaced(false)
                setWinningNumber(null)
            }
            setremainSeconds((prevSeconds) => prevSeconds - 1);
        }, 1000);
        return () => clearInterval(interval);

    }, [])
    return (
        <div className="losePopup">
            <div className="losePopupInner">
                <div className="ppTitle">
                    <h5>Sorry</h5>
                </div>
                <div className="lotteryResults">
                    <span>Lottery results </span>
                    <span className="lrTag">
                        {
                            winningNumber === 0 ? "Red,Violet" :
                                winningNumber === 5 ? "Green,Violet" :
                                    winningNumber % 2 === 0 ? "Red" : "Green"
                        }
                    </span>
                    <span className="lrTagCircle">{winningNumber}</span>
                    <span className="lrTag">{winningNumber >= 5 ? "Big" : "Small"}</span>
                </div>
                <div className="betWinLose">
                    <p>Lose</p>
                </div>
                <div className="resultId">
                    Period:{gameTime === "30S" ? "30 seconds " : gameTime === "1M" ? "1 Minute " : gameTime === "3M" ? "3 Minutes " : gameTime === "5M" ? "5 Minutes " : gameTime}
                    {/* {sessionId} */}
                    <Tooltip title={sessionId}>
                        <Typography.Text>{sessionId?.length > 15 ? `${sessionId.substring(0, 15)}...` : sessionId}</Typography.Text>
                    </Tooltip>
                </div>
                <div className="autoClose">
                    <span className={cookies?.autoClose ? "active" : ""} onClick={_toggleAutoClose}>
                        {cookies?.autoClose ? <CheckOutlined style={{ color: "#fff" }} color="#fff" /> : ""}
                    </span> {remainSeconds} seconds auto close
                </div>
                <button className="winloseClose" onClick={() => { setBetResult(null); setWinningNumber(null); setBetPlaced(false) }}>
                    <img src="/assets/images/close-84ce5e6a.png" alt="" />
                </button>
            </div>
        </div>
    )
}
const WinPopup = ({ betResult, setBetResult, currencySymbol, gameTime, sessionId, setBetPlaced }) => {

    const [cookies, setCookies, removeCookies] = useCookies();
    const [remainSeconds, setremainSeconds] = useState(3)

    useEffect(() => {
        if (remainSeconds === 0) {
            setBetResult(null);
            setBetPlaced(false);
        }
    }, [remainSeconds])
    useEffect(() => {
        if (cookies?.autoClose === undefined) return;

        const interval = setInterval(() => {
            if (remainSeconds <= 0) {
                setBetResult(null)
                setBetPlaced(null)
            }
            setremainSeconds((prevSeconds) => prevSeconds - 1);
        }, 1000);
        return () => clearInterval(interval);

    }, [])

    const _toggleAutoClose = () => {
        if (cookies?.autoClose) {
            removeCookies("autoClose", { path: "/" })
        }
        else {
            setCookies("autoClose", true, { path: "/" })
        }
    }

    return (
        <div className="losePopup winPopup">
            <div className="losePopupInner">
                <div className="ppTitle">
                    <h5>Congratulations</h5>
                </div>
                <div className="lotteryResults">
                    <span>Lottery results </span>
                    <span className="lrTag">{betResult?.sessionColor?.map((color, index) =>
                        betResult?.sessionColor?.[index + 1] ? color + ", " : color
                    )}</span>
                    <span className="lrTagCircle">{betResult?.sessionNumber}</span>
                    <span className="lrTag">{betResult?.bigSmall}</span>
                </div>
                <div className="betWinLose">
                    <span>Bonus</span>
                    <p>{currencySymbol + " "}{Number(betResult.winAmount).toFixed(2)}</p>
                </div>
                <div className="resultId">
                    Period:{gameTime === "30S" ? "30 seconds " : gameTime === "1M" ? "1 Minute " : gameTime === "3M" ? "3 Minutes " : gameTime === "5M" ? "5 Minutes " : gameTime}
                    {/* {sessionId} */}
                    <Tooltip title={sessionId}>
                        <Typography.Text>{sessionId.length > 15 ? `${sessionId.substring(0, 15)}...` : sessionId}</Typography.Text>
                    </Tooltip>
                </div>
                <div className="autoClose">
                    <span className={cookies?.autoClose ? "active" : ""} onClick={_toggleAutoClose}>
                        {cookies?.autoClose ? <CheckOutlined /> : ""}
                    </span> {remainSeconds} seconds auto close
                </div>
                <button className="winloseClose" onClick={() => { setBetResult(null); setBetPlaced(false) }}>
                    <img src="/assets/images/close-84ce5e6a.png" alt="" />
                </button>
            </div>
        </div>
    )
}
